import { ReportHandler } from 'web-vitals';

/**
 * Función para reportar métricas de rendimiento web usando la librería 'web-vitals'.
 * 
 * - Recibe una función opcional `onPerfEntry` para manejar las métricas.
 * - Si se proporciona y es una función, importa dinámicamente las funciones de métricas web.
 * - Ejecuta las funciones de métrica (CLS, FID, FCP, LCP, TTFB) pasando el callback `onPerfEntry`.
 * 
 * @param onPerfEntry Función opcional para manejar las métricas de rendimiento.
 */
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
